<span *ngIf="restaurantId">
  <div class="grid">
    <div *ngIf="component" class="k-toolbar k-grid-toolbar custom-toolbar">
      <div class="filters-section">
        <kendo-dropdownlist
          [data]="productTypes"
          [(ngModel)]="productType"
          textField="name"
          valueField="id"
        ></kendo-dropdownlist>
        
        <kendo-dropdownlist
          [data]="categories"
          [(ngModel)]="selectedCategory"
          textField="name"
          valueField="id"
          (ngModelChange)="updateParameters()"
          [defaultItem]="defaultCategory"
        ></kendo-dropdownlist>
        <app-delivery-price-message></app-delivery-price-message>
      </div>
      <div class="buttons-section">
        <button
          kendoTooltip
          kendoButton
          [title]="rbiRecommendationsDate ? 'Load RBI recommended prices as of ' + (rbiRecommendationsDate | date:'MMMM yyyy') : 'This button is disabled because there are no RBI recommendations loaded for the selected tier.'"
          size="small"
          fillMode="outline"
          (click)="showLoadRbiRecommendationsConfirmation = true"
          themeColor="primary"
          [disabled]="!rbiRecommendationsDate || isBundleView"
        >
          Load RBI Recommendations
        </button>
        
        <kendo-badge-container>
          <button
            kendoButton
            size="small"
            fillMode="outline"
            [disabled]="component.cache.size == 0"
            (click)="saveChanges()"
            themeColor="primary"
          >
            Save
          </button>
          <kendo-badge
            *ngIf="component.cache.size > 0"
            size="small"
            rounded="full"
            [align]="{ vertical: 'top', horizontal: 'end' }"
            themeColor="success"
            >{{ component.cache.size }}</kendo-badge
          >
        </kendo-badge-container>

        <app-grid-manager-toolbar
          [showConfig]="false"
          [showDelivery]="true"
          [showBulkDelivery]="productType.id === 'aLaCarte' || productType.id === 'combo' || productType.id === 'kidmeal'"
          [tierLocked]="locked"
          [showImport]="locked ? [] : ['Current Type', 'All']"
          [showExport]="[
            'Current Type',
            'Current Type (All Tiers)',
            'Tier',
            'All'
          ]"
          (exportToExcel)="exportToExcel($event)"
          (uploadSuccessful)="updatePendingChanges()"
          (openDeliverySettings)="showDeliverySettings = true"
          (openBulkDeliveryChange)="showDeliveryPanel = true"
          [fontSize]="component.fontSize"
          (fontSizeChange)="updateFontSize($event)"
          [columns]="component.columns"
          [importUrl]="component.importUrls"
          view="pricing"
        ></app-grid-manager-toolbar>
      </div>
    </div>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</span>


<kendo-dialog
  *ngIf="showDeliverySettings"
  (close)="showDeliverySettings = false"
  [width]="600"
  title="Delivery Settings"
>
  <p style="font-size: 12px; color: #888; margin: 0 0 12px 0; line-height: 1.5;">
    Configure the upcharge % and rounding rules for this tier.
    These settings apply to <strong>all delivery items</strong> across the entire tier.
  </p>
  <app-configuration></app-configuration>
</kendo-dialog>

<kendo-dialog
  *ngIf="showDeliveryPanel"
  (close)="showDeliveryPanel = false"
  [width]="560"
  title="Bulk Delivery % Change"
>
  <app-delivery-management
    [productType]="productType"
    [categories]="categories"
    [tierId]="tier?.id"
    [gridData]="component?.changeset?.data || []"
    (bulkApplied)="onBulkDeliveryApplied()"
    (close)="showDeliveryPanel = false"
  ></app-delivery-management>
</kendo-dialog>

<kendo-dialog
  *ngIf="pendingExportOption"
  (close)="pendingExportOption = null"
  [width]="420"
  [title]="'Export ' + pendingExportOption"
>
  <p style="margin: 0 0 12px 0">Items to include:</p>
  <div style="display: flex; flex-direction: column; gap: 8px">
    <label *ngFor="let option of exportActiveFilterOptions">
      <input
        type="radio"
        kendoRadioButton
        name="exportActiveFilter"
        [value]="option.value"
        [(ngModel)]="exportActiveFilter"
      />
      {{ option.text }}
    </label>
  </div>

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="pendingExportOption = null">Cancel</button>
    <button kendoButton (click)="confirmExport()" themeColor="primary">
      Export
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  [width]="700"
  *ngIf="showLoadRbiRecommendationsConfirmation"
  (close)="showLoadRbiRecommendationsConfirmation = false"
>
  <kendo-dialog-titlebar> Load RBI Recommendations </kendo-dialog-titlebar>

  <p>Are you sure you want to load RBI recommended prices as of <strong>{{rbiRecommendationsDate | date:'MMMM yyyy'}}</strong>?</p>

  <p>Prices will be saved for you to sync when ready.</p>

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="showLoadRbiRecommendationsConfirmation = false">Cancel</button>
    <button
      kendoButton
      (click)="loadRbiRecommendations()"
      themeColor="primary"
    >
      Load
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
